import * as React from "react";
const SvgFiBrandsCreativeCommonsPdAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-creative-commons-pd-alt_svg__a)">
      <path d="M24 12q0 5.04-3.424 8.43Q16.94 24 11.984 24q-4.895 0-8.439-3.54T0 12t3.544-8.52Q6.998 0 11.984 0q5.048 0 8.532 3.48T24 12m-4.986 6.87q2.824-2.73 2.824-6.87.001-4.11-2.884-6.96-2.854-2.88-6.939-2.88T5.107 5.04Q2.163 8.01 2.163 12t2.913 6.9 6.939 2.91 6.999-2.94" />
      <path d="M15.127 8.618c2.02 0 3.381.96 3.381 3.316 0 2.358-1.36 3.317-3.381 3.317h-2.571V8.618zm.038 5.236c1.239 0 1.687-.847 1.687-1.919 0-1.07-.448-1.919-1.696-1.919h-.942v3.838zM12.105 10.865c0 .883-.494 2.244-2.766 2.244H8.044v2.142H6.367V8.619h3.288c1.789 0 2.45.932 2.45 2.246m-2.683 1.014c.755 0 1.025-.494 1.025-1.006 0-.662-.316-1.025-1.071-1.025H8.025v2.031z" />
    </g>
    <defs>
      <clipPath id="fi-brands-creative-commons-pd-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsCreativeCommonsPdAlt;
